// extracted by mini-css-extract-plugin
module.exports = {"chatAssistantButton":"ChatButton_chatAssistantButton__um2LR"};